import { render, staticRenderFns } from "./ksAssetList.vue?vue&type=template&id=1042a7ec&scoped=true&"
import script from "./ksAssetList.vue?vue&type=script&lang=js&"
export * from "./ksAssetList.vue?vue&type=script&lang=js&"
import style0 from "./ksAssetList.vue?vue&type=style&index=0&id=1042a7ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1042a7ec",
  null
  
)

export default component.exports